import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Group } from "../utils/logger";

// Themes
// import light from "./light";
// import dark from "./dark";

const LoggerGroup = new Group("Theme", { disable: true });

function themeCreator(theme: string): any {
  return themeMap[theme];
}

const themeMap: { [key: string]: any } = {
  //light,
  //dark,
};

const ThemeProvider = (props: any) => {
  // Get the theme object by theme name
  const theme = themeCreator(props.theme);

  LoggerGroup.emit("Selected theme", props.theme, { dir: theme });

  return <Fragment>{props.children}</Fragment>;
};

interface State {
  settings: {
    loading: boolean;
    theme: string;
  };
}

const mapStateToProps = (state: State) => ({
  theme: state.settings.theme,
});

export default connect(mapStateToProps)(ThemeProvider);
